module.exports = __webpack_public_path__ + "img/LECLERCQ.67110e79.png";